import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { I_Document } from 'src/app/utils/interfaces';

export class InputErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    if (!form) return true;
    if (!control) return true;

    if (!control.pristine) {
      return !control.invalid && typeof control.value !== 'string' && (control.value as I_Document)?._id ? false : true;
    }
  }
}
